export default "__VITE_PUBLIC_ASSET__b61ce9fe__"